<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyCategoryListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyCategoryListing from "@/views/pages/admin/propertyCategory/propertyCategoryListing";

export default {
    page: {
        title: i18n.t("module.propertyCategory"),
    },
    components: { Layout, PageHeader, PropertyCategoryListing },
    data() {
        return {
            title: i18n.t("module.propertyCategory"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyCategory"),
                    active: true,
                },
            ],
        };
    },
}
</script>
